import Vue from "vue";
// import { isString, isObject } from 'element-ui/src/utils/types';

const hasOwnProperty = Object.prototype.hasOwnProperty;

export function noop() {}

export function hasOwn(obj, key) {
  return hasOwnProperty.call(obj, key);
}

function extend(to, _from) {
  for (let key in _from) {
    to[key] = _from[key];
  }
  return to;
}

export function toObject(arr) {
  var res = {};
  for (let i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res;
}

export const getValueByPath = function (object, prop) {
  prop = prop || "";
  const paths = prop.split(".");
  let current = object;
  let result = null;
  for (let i = 0, j = paths.length; i < j; i++) {
    const path = paths[i];
    if (!current) break;

    if (i === j - 1) {
      result = current[path];
      break;
    }
    current = current[path];
  }
  return result;
};

export function getPropByPath(obj, path, strict) {
  let tempObj = obj;
  path = path.replace(/\[(\w+)\]/g, ".$1");
  path = path.replace(/^\./, "");

  let keyArr = path.split(".");
  let i = 0;
  for (let len = keyArr.length; i < len - 1; ++i) {
    if (!tempObj && !strict) break;
    let key = keyArr[i];
    if (key in tempObj) {
      tempObj = tempObj[key];
    } else {
      if (strict) {
        throw new Error("please transfer a valid prop path to form item!");
      }
      break;
    }
  }
  return {
    o: tempObj,
    k: keyArr[i],
    v: tempObj ? tempObj[keyArr[i]] : null
  };
}

export const generateId = function () {
  return Math.floor(Math.random() * 10000);
};

export const valueEquals = (a, b) => {
  // see: https://stackoverflow.com/questions/3115982/how-to-check-if-two-arrays-are-equal-with-javascript
  if (a === b) return true;
  if (!(a instanceof Array)) return false;
  if (!(b instanceof Array)) return false;
  if (a.length !== b.length) return false;
  for (let i = 0; i !== a.length; ++i) {
    if (a[i] !== b[i]) return false;
  }
  return true;
};

export const escapeRegexpString = (value = "") =>
  String(value).replace(/[|\\{}()[\]^$+*?.]/g, "\\$&");

// TODO: use native Array.find, Array.findIndex when IE support is dropped
export const arrayFindIndex = function (arr, pred) {
  for (let i = 0; i !== arr.length; ++i) {
    if (pred(arr[i])) {
      return i;
    }
  }
  return -1;
};

export const arrayFind = function (arr, pred) {
  const idx = arrayFindIndex(arr, pred);
  return idx !== -1 ? arr[idx] : undefined;
};

// coerce truthy value to array
export const coerceTruthyValueToArray = function (val) {
  if (Array.isArray(val)) {
    return val;
  } else if (val) {
    return [val];
  } else {
    return [];
  }
};

export const isIE = function () {
  return !Vue.prototype.$isServer && !isNaN(Number(document.documentMode));
};

export const isEdge = function () {
  return !Vue.prototype.$isServer && navigator.userAgent.indexOf("Edge") > -1;
};

export const isFirefox = function () {
  return (
    !Vue.prototype.$isServer && !!window.navigator.userAgent.match(/firefox/i)
  );
};

export const autoprefixer = function (style) {
  if (typeof style !== "object") return style;
  const rules = ["transform", "transition", "animation"];
  const prefixes = ["ms-", "webkit-"];
  rules.forEach((rule) => {
    const value = style[rule];
    if (rule && value) {
      prefixes.forEach((prefix) => {
        style[prefix + rule] = value;
      });
    }
  });
  return style;
};

export const kebabCase = function (str) {
  const hyphenateRE = /([^-])([A-Z])/g;
  return str
    .replace(hyphenateRE, "$1-$2")
    .replace(hyphenateRE, "$1-$2")
    .toLowerCase();
};

// export const capitalize = function(str) {
//   if (!isString(str)) return str;
//   return str.charAt(0).toUpperCase() + str.slice(1);
// };

// export const looseEqual = function(a, b) {
//   const isObjectA = isObject(a);
//   const isObjectB = isObject(b);
//   if (isObjectA && isObjectB) {
//     return JSON.stringify(a) === JSON.stringify(b);
//   } else if (!isObjectA && !isObjectB) {
//     return String(a) === String(b);
//   } else {
//     return false;
//   }
// };

// export const arrayEquals = function (arrayA, arrayB) {
//   arrayA = arrayA || [];
//   arrayB = arrayB || [];

//   if (arrayA.length !== arrayB.length) {
//     return false;
//   }

//   for (let i = 0; i < arrayA.length; i++) {
//     if (!looseEqual(arrayA[i], arrayB[i])) {
//       return false;
//     }
//   }

//   return true;
// };

// export const isEqual = function (value1, value2) {
//   if (Array.isArray(value1) && Array.isArray(value2)) {
//     return arrayEquals(value1, value2);
//   }
//   return looseEqual(value1, value2);
// };

export const isEmpty = function (val) {
  // null or undefined
  if (val == null) return true;

  if (typeof val === "boolean") return false;

  if (typeof val === "number") return !val;

  if (val instanceof Error) return val.message === "";

  switch (Object.prototype.toString.call(val)) {
    // String or Array
    case "[object String]":
    case "[object Array]":
      return !val.length;

    // Map or Set or File
    case "[object File]":
    case "[object Map]":
    case "[object Set]": {
      return !val.size;
    }
    // Plain Object
    case "[object Object]": {
      return !Object.keys(val).length;
    }
  }

  return false;
};

export function rafThrottle(fn) {
  let locked = false;
  return function (...args) {
    if (locked) return;
    locked = true;
    window.requestAnimationFrame(() => {
      fn.apply(this, args);
      locked = false;
    });
  };
}

export function objToArray(obj) {
  if (Array.isArray(obj)) {
    return obj;
  }
  return isEmpty(obj) ? [] : [obj];
}
/**
 * OSS前缀上传路径
 * @param {*} type 类型值
 * /avatar - 团队介绍头像
 */
export function ossPrefixPath(type) {
  let prefixPath = "";
  switch (type) {
    case 0:
      prefixPath = "agent/pic/";
      break;
    case 1:
      prefixPath = "agent/video/";
      break;

    default:
      break;
  }
  return prefixPath;
}

/**
 * @description 深度克隆
 * @param {object} obj 需要深度克隆的对象
 * @param cache 缓存
 * @returns {*} 克隆后的对象或者原值（不是对象）
 */
export function deepClone(obj, cache = new WeakMap()) {
  if (obj === null || typeof obj !== 'object') return obj;
  if (cache.has(obj)) return cache.get(obj);
  let clone;
  if (obj instanceof Date) {
    clone = new Date(obj.getTime());
  } else if (obj instanceof RegExp) {
    clone = new RegExp(obj);
  } else if (obj instanceof Map) {
    clone = new Map(Array.from(obj, ([key, value]) => [key, deepClone(value, cache)]));
  } else if (obj instanceof Set) {
    clone = new Set(Array.from(obj, value => deepClone(value, cache)));
  } else if (Array.isArray(obj)) {
    clone = obj.map(value => deepClone(value, cache));
  } else if (Object.prototype.toString.call(obj) === '[object Object]') {
    clone = Object.create(Object.getPrototypeOf(obj));
    cache.set(obj, clone);
    for (const [key, value] of Object.entries(obj)) {
      clone[key] = deepClone(value, cache);
    }
  } else {
    clone = Object.assign({}, obj);
  }
  cache.set(obj, clone);
  return clone;
}

const emptyReg = /^[\s]*$/
export function isEmptyVal(value) {
  return !value || (value && emptyReg.test(value))
}
/**
 * @description 备注校验必填且字符不能都为空白字符
 * @returns {*} { type: 浏览器类型, version: 版本号 }
 */
export function remarkValidator(fieldName = '内容', rule, value, callback) {
  if (!value) {
    return callback(new Error(`请输入${fieldName}`))
  } else if (isEmptyVal(value)) {
    return callback(new Error(`${fieldName}不允许为空，请检查`))
  } else {
    return callback()
  }
}

/**
 * @description 获取浏览器类型和版本号
 * @returns {*} { type: 浏览器类型, version: 版本号 }
 */
export function getExplore() {
  const userAgent = navigator.userAgent;

  const browsers = [
    {
      name: "Mozilla Firefox",
      pattern: /Firefox\/([0-9.]+)/,
      check: () => userAgent.includes("Firefox") && !userAgent.includes("Seamonkey")
    },
    {
      name: "Samsung Internet",
      pattern: /SamsungBrowser\/([0-9.]+)/,
      check: () => userAgent.includes("SamsungBrowser")
    },
    {
      name: "Opera",
      pattern: /(?:Opera|OPR)\/([0-9.]+)/,
      check: () => userAgent.includes("Opera") || userAgent.includes("OPR/")
    },
    {
      name: "Microsoft Edge (Chromium)",
      pattern: /Edg\/([0-9.]+)/,
      check: () => userAgent.includes("Edg/")
    },
    {
      name: "Microsoft Edge (Legacy)",
      pattern: /Edge\/([0-9.]+)/,
      check: () => userAgent.includes("Edge") && !userAgent.includes("Edg")
    },
    {
      name: "Google Chrome",
      pattern: /Chrome\/([0-9.]+)/,
      check: () => userAgent.includes("Chrome") && !userAgent.includes("Edg") && !userAgent.includes("OPR")
    },
    {
      name: "Safari",
      pattern: /Version\/([0-9.]+)/,
      check: () => userAgent.includes("Safari") && !userAgent.includes("Chrome")
    },
    {
      name: "Internet Explorer",
      pattern: /(?:MSIE |rv:)([0-9.]+)/,
      check: () => userAgent.includes("MSIE") || userAgent.includes("Trident/")
    }
  ];

  for (const browser of browsers) {
    if (browser.check()) {
      const match = userAgent.match(browser.pattern);
      if (match) {
        return {
          name: browser.name,
          fullVersion: match[1],
          version: match[1].split(".")[0],
        };
      }
      return {
        name: browser.name,
        fullVersion: "Unknown",
        version: "Unknown",
      };
    }
  }

  return {
    name: "Unknown",
    fullVersion: "Unknown",
    version: "Unknown",
  };
}

export function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null;
  }
  const format = cFormat || "{y}-{m}-{d} {h}:{i}:{s}";
  let date;
  if (typeof time === "object") {
    date = time;
  } else {
    if (("" + time).length === 10) time = parseInt(time) * 1000;
    date = new Date(time);
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay(),
  };
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key];
    if (key === "a")
      return ["一", "二", "三", "四", "五", "六", "日"][value - 1];
    if (result.length > 0 && value < 10) {
      value = "0" + value;
    }
    return value || 0;
  });
  return time_str;
}


export async function getModernOSInfo() {
  const userAgent = navigator.userAgent;

  let osInfo = {
    name: "Unknown",
    version: "Unknown",
    versionName: "Unknown",
    fullVersion: ""
  };

  // 使用新的 Navigator API (如果支持)
  if (navigator.userAgentData) {
    try {
      const platformData = await navigator.userAgentData.getHighEntropyValues(["platform", "platformVersion", "architecture"]);

      if (platformData.platform && platformData.platformVersion) {
        osInfo.name = platformData.platform;
        osInfo.fullVersion = platformData.platformVersion;

        // 处理不同操作系统的版本信息
        if (platformData.platform === "Windows") {
          osInfo = { ...osInfo, ...getWindowsVersionInfo(platformData.platformVersion) };
        } else if (platformData.platform === "macOS") {
          osInfo = { ...osInfo, ...getMacOSVersionInfo(platformData.platformVersion) };
        } else if (platformData.platform === "Linux") {
          osInfo.version = "Linux";
          osInfo.versionName = "Linux";
        }

        return osInfo;
      }
    } catch (error) {
      console.log("无法通过现代 API 获取系统信息:", error);
    }
  }

  // 回退到传统方法 - 基于 User Agent 检测
  return getOSTraditionalMethod(userAgent);
}

// Windows 版本信息解析
function getWindowsVersionInfo(platformVersion) {
  const result = {
    version: platformVersion,
    versionName: "Unknown Windows"
  };

  const majorPlatformVersion = parseInt(platformVersion.split('.')[0]);
  if (majorPlatformVersion >= 13) {
    result.versionName = "Windows 11";
  }
  else if (majorPlatformVersion > 0) {
    result.versionName = "Windows 10";
  } else {
    // 判断不出window11 可能企业版修改了信息吧 暂不清楚 !!!
    // if (platformVersion.startsWith("10.0.")) {
    //   const buildNumber = parseInt(platformVersion.split(".")[2]);
    //   // Windows 11 的构建号通常 >= 22000
    //   if (buildNumber >= 22000) {
    //     result.versionName = "Windows 11";
    //   }
    //   // Windows 10 的构建号通常在 10240-19045 范围内
    //   else if (buildNumber >= 10240) {
    //     result.versionName = "Windows 10";
    //   }
    //   // Windows 12 目前尚未发布，假设构建号会更高
    //   else if (buildNumber >= 25000) {
    //     result.versionName = "Windows 12";
    //   }
    //   else {
    //     result.versionName = "Windows 10/11";
    //   }
    // } else 
    if (platformVersion.startsWith("6.3")) {
      result.versionName = "Windows 8.1";
    } else if (platformVersion.startsWith("6.2")) {
      result.versionName = "Windows 8";
    } else if (platformVersion.startsWith("6.1")) {
      result.versionName = "Windows 7";
    } else if (platformVersion.startsWith("6.0")) {
      result.versionName = "Windows Vista";
    } else if (platformVersion.startsWith("5.1")) {
      result.versionName = "Windows XP";
    }
  }
  return result;
}

// macOS 版本信息解析
function getMacOSVersionInfo(platformVersion) {
  const result = {
    version: platformVersion,
    versionName: "Unknown macOS"
  };

  // 解析 macOS 版本
  const versionParts = platformVersion.split(".");
  const majorVersion = parseInt(versionParts[0]);
  const minorVersion = parseInt(versionParts[1] || "0");

  // macOS 版本映射
  if (majorVersion === 10) {
    const macOSVersions = {
      0: "Cheetah",
      1: "Puma",
      2: "Jaguar",
      3: "Panther",
      4: "Tiger",
      5: "Leopard",
      6: "Snow Leopard",
      7: "Lion",
      8: "Mountain Lion",
      9: "Mavericks",
      10: "Yosemite",
      11: "El Capitan",
      12: "Sierra",
      13: "High Sierra",
      14: "Mojave",
      15: "Catalina"
    };
    result.versionName = macOSVersions[minorVersion] || `macOS 10.${minorVersion}`;
  } else if (majorVersion >= 11) {
    const modernMacOSVersions = {
      11: "Big Sur",
      12: "Monterey",
      13: "Ventura",
      14: "Sonoma"
    };
    result.versionName = modernMacOSVersions[majorVersion] || `macOS ${majorVersion}`;
  }

  return result;
}

// 传统方法 - 基于 User Agent 检测
function getOSTraditionalMethod(userAgent) {
  const osInfo = {
    name: "Unknown",
    version: "Unknown",
    versionName: "Unknown",
    fullVersion: ""
  };

  // Windows 检测
  if (userAgent.includes("Windows")) {
    osInfo.name = "Windows";

    // Windows 11/10 检测
    if (userAgent.includes("Windows NT 10.0")) {
      osInfo.version = "10.0";
      // 通过 userAgent 很难准确区分 Windows 10 和 11
      // 只能给出推测性结果
      osInfo.versionName = "Windows 10/11";
      osInfo.fullVersion = "NT 10.0";
    } else if (userAgent.includes("Windows NT 6.3")) {
      osInfo.version = "6.3";
      osInfo.versionName = "Windows 8.1";
      osInfo.fullVersion = "NT 6.3";
    } else if (userAgent.includes("Windows NT 6.2")) {
      osInfo.version = "6.2";
      osInfo.versionName = "Windows 8";
      osInfo.fullVersion = "NT 6.2";
    } else if (userAgent.includes("Windows NT 6.1")) {
      osInfo.version = "6.1";
      osInfo.versionName = "Windows 7";
      osInfo.fullVersion = "NT 6.1";
    } else if (userAgent.includes("Windows NT 6.0")) {
      osInfo.version = "6.0";
      osInfo.versionName = "Windows Vista";
      osInfo.fullVersion = "NT 6.0";
    } else if (userAgent.includes("Windows NT 5.1")) {
      osInfo.version = "5.1";
      osInfo.versionName = "Windows XP";
      osInfo.fullVersion = "NT 5.1";
    }

    return osInfo;
  }

  // macOS 检测
  if (userAgent.includes("Mac OS X")) {
    osInfo.name = "macOS";

    // 提取 macOS 版本
    const versionMatch = userAgent.match(/Mac OS X ([0-9_]+)/);
    if (versionMatch) {
      const versionString = versionMatch[1].replace(/_/g, ".");
      osInfo.version = versionString;
      osInfo.fullVersion = versionString;
      osInfo.versionName = getMacOSVersionName(versionString);
    }

    return osInfo;
  }

  // Linux 检测
  if (userAgent.includes("Linux")) {
    osInfo.name = "Linux";
    osInfo.version = "Unknown";
    osInfo.versionName = "Linux";

    // 检测具体的 Linux 发行版
    if (userAgent.includes("Ubuntu")) {
      osInfo.versionName = "Ubuntu";
    } else if (userAgent.includes("Fedora")) {
      osInfo.versionName = "Fedora";
    } else if (userAgent.includes("Debian")) {
      osInfo.versionName = "Debian";
    }

    return osInfo;
  }

  // Android 检测
  if (userAgent.includes("Android")) {
    osInfo.name = "Android";
    const androidMatch = userAgent.match(/Android ([0-9.]+)/);
    if (androidMatch) {
      osInfo.version = androidMatch[1];
      osInfo.fullVersion = androidMatch[1];
      osInfo.versionName = `Android ${androidMatch[1]}`;
    }
    return osInfo;
  }

  // iOS 检测
  if (userAgent.includes("iPhone") || userAgent.includes("iPad")) {
    osInfo.name = "iOS";
    const iosMatch = userAgent.match(/OS ([0-9_]+)/);
    if (iosMatch) {
      const versionString = iosMatch[1].replace(/_/g, ".");
      osInfo.version = versionString;
      osInfo.fullVersion = versionString;
      osInfo.versionName = `iOS ${versionString}`;
    }
    return osInfo;
  }

  return osInfo;
}

// 辅助函数：获取 macOS 版本名称
function getMacOSVersionName(version) {
  const versionMap = { 
    "10.15": "Catalina",
    "10.14": "Mojave",
    "10.13": "High Sierra",
    "10.12": "Sierra",
    "10.11": "El Capitan",
    "10.10": "Yosemite",
    "10.9": "Mavericks",
    "10.8": "Mountain Lion",
    "10.7": "Lion",
    "10.6": "Snow Leopard",
    "10.5": "Leopard",
    "10.4": "Tiger",
    "10.3": "Panther",
    "10.2": "Jaguar",
    "10.1": "Puma",
    "10.0": "Cheetah",
    "11": "Big Sur",
    "12": "Monterey",
    "13": "Ventura",
    "14": "Sonoma",
    "15": "Sequoia",
    "26": "Tahoe"
  };

  // 精确匹配
  if (versionMap[version]) {
    return versionMap[version];
  }

  // 前缀匹配
  for (const [ver, name] of Object.entries(versionMap)) {
    if (version.startsWith(ver)) {
      return name;
    }
  }

  // 处理未来版本
  const majorVersion = parseInt(version.split(".")[0]);
  if (majorVersion > 15) {
    return `macOS ${majorVersion}`;
  }

  return "Unknown Version";
}

export const mobileReg = /^1[3456789]\d{9}$/
export const  mobileValidator = (rule, value, callback) => {
  if (!value) {
    return callback()
  } else if (!mobileReg.test(value)) {
    return callback(new Error('手机号格式不正确'))
  } else {
    return callback()
  }
}

export const getUrls = (data) => {
  return data? data.map(item => {
    if(typeof item === 'string') {
      return item
    } else if(item.url.indexOf('http') === 0) {
      return item.url
    } else {
      return item.response
    }
  }) : []
}